/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { continueBuildingWallStorage } from '../../../analytics';

export default (set, get, eventData = {}) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  continueBuildingWallStorage(eventData);
}), false, { type: 'TRACK_CONTINUE_BUILDING_WALL_STORAGE_CLICK' });
